import script from './script'

const controller = () => {
    return { script }
}
export default controller